import { createReducer } from 'typesafe-actions';
import {
  INIT_DOCUMENTS,
  INIT_DOCUMENTS_CURRENT_ID,
  UPDATE_DOCUMENTS_CURRENT_ID,
  UPDATE_DOCUMENTS_OPTIONS
} from './actions';
import { Action, DocumentsFields } from './types';

export const initialState: DocumentsFields = {
  options: {
    listAnchorId: null
  }
};

export const documents = createReducer<DocumentsFields, Action>(initialState, {
  [INIT_DOCUMENTS]: () => {
    return initialState;
  },

  [INIT_DOCUMENTS_CURRENT_ID]: (state) => {
    return {
      ...state,
      selectedPurchaseOrderId: undefined,
      selectedQuotationId: undefined
    };
  },

  [UPDATE_DOCUMENTS_CURRENT_ID]: (state, action) => {
    return {
      ...state,
      selectedPurchaseOrderId: action.payload.selectedPurchaseOrderId
        ? action.payload.selectedPurchaseOrderId
        : state.selectedPurchaseOrderId,
      selectedQuotationId: action.payload.selectedQuotationId
        ? action.payload.selectedQuotationId
        : state.selectedQuotationId
    };
  },
  [UPDATE_DOCUMENTS_OPTIONS]: (state, action) => {
    return {
      ...state,
      options: {
        ...state.options,
        ...action.payload
      }
    };
  }
});
